import { Spinner, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { CustomStandardModal } from '@app/components/Modal';

import styles from '../../styles/configure-voice.module.scss';

type LoadingE911ModalProps = {
  isOpen: boolean;
};

export const LoadingE911Modal = ({ isOpen }: LoadingE911ModalProps) => {
  const { t } = useTranslation('ShopAddons');
  return (
    <CustomStandardModal
      isOpen={isOpen}
      header={undefined}
      actions={{
        primary: { label: '', style: { display: 'none' } },
        secondary: undefined,
      }}
      surfaceProps={{ className: styles['loading-scrub-address-modal'] }}
    >
      <div>
        <Spinner description={<Txt color="subtle">{t('voice.emergencyAddress.loading')}</Txt>} />
      </div>
    </CustomStandardModal>
  );
};
